var _rect, _path, _path2, _line, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintExitTicketBackIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 141,
    viewBox: "0 0 206 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 204.512,
    height: 140.5,
    fill: "#F2F7FF",
    fillOpacity: 0.5,
    stroke: "black",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83829 12.9202L7.10929 7.98517H7.85129L9.17429 11.8702L10.5323 7.98517H11.0853L12.4293 11.9122L13.7803 7.98517H14.4873L12.7443 12.9202H12.1353L10.7983 9.08417L9.44729 12.9202H8.83829ZM16.5902 12.9202L14.8612 7.98517H15.6032L16.9262 11.8702L18.2842 7.98517H18.8372L20.1812 11.9122L21.5322 7.98517H22.2392L20.4962 12.9202H19.8872L18.5502 9.08417L17.1992 12.9202H16.5902ZM24.3422 12.9202L22.6132 7.98517H23.3552L24.6782 11.8702L26.0362 7.98517H26.5892L27.9332 11.9122L29.2842 7.98517H29.9912L28.2482 12.9202H27.6392L26.3022 9.08417L24.9512 12.9202H24.3422Z",
    fill: "#4E89E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.574 75V70.065H9.766V70.653H7.274V72.2H9.619V72.788H7.274V74.412H9.766V75H6.574ZM10.6961 75V70.065H12.7541C13.2674 70.065 13.6641 70.1793 13.9441 70.408C14.2287 70.632 14.3711 70.947 14.3711 71.353C14.3711 71.619 14.3011 71.8477 14.1611 72.039C14.0211 72.2303 13.8297 72.3703 13.5871 72.459C13.8717 72.5337 14.0934 72.6713 14.2521 72.872C14.4107 73.0727 14.4901 73.327 14.4901 73.635C14.4901 74.0737 14.3431 74.412 14.0491 74.65C13.7597 74.8833 13.3561 75 12.8381 75H10.6961ZM11.3961 72.221H12.6421C13.3234 72.221 13.6641 71.955 13.6641 71.423C13.6641 70.891 13.3234 70.625 12.6421 70.625H11.3961V72.221ZM11.3961 74.44H12.7541C13.4401 74.44 13.7831 74.1623 13.7831 73.607C13.7831 73.0563 13.4401 72.781 12.7541 72.781H11.3961V74.44ZM15.4676 75V70.065H16.1956V75H15.4676Z",
    fill: "#4E89E2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 101.5,
    y1: 4.8252,
    x2: 101.5,
    y2: 137.04,
    stroke: "#484848",
    strokeLinecap: "round",
    strokeDasharray: "3 6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 86.5,
    r: 1.35,
    stroke: "#1660E7",
    strokeWidth: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 23.5,
    r: 1.35,
    stroke: "#1660E7",
    strokeWidth: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 95.5,
    r: 1.35,
    stroke: "#1660E7",
    strokeWidth: 0.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 32.5,
    r: 1.35,
    stroke: "#1660E7",
    strokeWidth: 0.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 104.5,
    r: 1.35,
    stroke: "#1660E7",
    strokeWidth: 0.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 41.5,
    r: 1.35,
    stroke: "#1660E7",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintExitTicketBackIllustration);
export default __webpack_public_path__ + "static/media/print-exit-ticket-back-illustration.b588073e129972f53cfe34c2930e8b3a.svg";
export { ForwardRef as ReactComponent };